function showQuantityConfirmModal(): Promise<boolean> {
  return new Promise((resolve) => {
    const modal = document.querySelector<HTMLElement>(
      "[data-discount-warning-banner]"
    );
    const overlay = document.querySelector("[data-discount-warning-banner-overlay]");
    if (!(modal instanceof HTMLElement)) return resolve(true);

    const yesBtn = modal.querySelector("[data-confirm-yes]");
    const noBtn = modal.querySelector("[data-confirm-no]");

    function cleanup() {
      modal.classList.remove("discount-warning__visible");
      if (overlay instanceof HTMLElement) {
        overlay.classList.remove("discount-warning__overlay-is-visible");
      }
      yesBtn?.removeEventListener("click", onYes);
      noBtn?.removeEventListener("click", onNo);
    }

    function onYes() {
      cleanup();
      resolve(true);
    }
    function onNo() {
      cleanup();
      resolve(false);
    }

    modal.classList.add("discount-warning__visible");
    if (overlay instanceof HTMLElement) {
      overlay.classList.add("discount-warning__overlay-is-visible");
    }
    yesBtn?.addEventListener("click", onYes, { once: true });
    noBtn?.addEventListener("click", onNo, { once: true });
  });
}

function bindQuantityTrackingListeners() {
  const root = document.body || document.documentElement;
  if (!root || root.hasAttribute("data-quantity-listeners-bound")) return;
  document.addEventListener("focusin", (e) => {
    if (!(e.target instanceof HTMLInputElement)) return;
    if (e.target.classList.contains("quantity-input")) {
      e.target.dataset.prevValue = e.target.value;
    }
  });

  document.addEventListener("mousedown", (e) => {
    const target = e.target;
    if (!(target instanceof HTMLElement)) return;
    if (target.classList.contains("quantity-button")) {
      const inputButtons = target.closest(".quantity-input-buttons");
      if (!inputButtons) return;
      const input = inputButtons.querySelector(".quantity-input");
      if (input instanceof HTMLInputElement) {
        input.dataset.prevValue = input.value;
      }
    }
  });
  root.setAttribute("data-quantity-listeners-bound", "true");
}

function patchChangeLineItemQuantity() {
  const el = document.querySelector("line-item-quantity");
  if (!el) return;
  const proto = Object.getPrototypeOf(el);
  if (!proto._changeLineItemQuantity || proto._changeLineItemQuantity.__patched)
    return;

  const originalChange = proto._changeLineItemQuantity;
  proto._changeLineItemQuantity = async function (...args) {
    const input = this.querySelector("input.quantity-input");
    const oldQuantity =
      args[2] ?? (input ? parseInt(input.defaultValue, 10) : NaN);
    const targetQuantity = args[1];

    if (
      !isNaN(oldQuantity) &&
      typeof targetQuantity === "number" &&
      targetQuantity < oldQuantity
    ) {
      const confirmed = await showQuantityConfirmModal();
      if (!confirmed) {
        if (input) input.value = oldQuantity.toString();

        const decreaseBtn = this.querySelector(".quantity-button.decrease");
        if (decreaseBtn) decreaseBtn.disabled = oldQuantity <= 0;

        return;
      }
    }
    return originalChange.apply(this, args);
  };
  proto._changeLineItemQuantity.__patched = true;
}

function rebindQuantityListeners() {
  bindQuantityTrackingListeners();
  patchChangeLineItemQuantity();
}

document.addEventListener("DOMContentLoaded", rebindQuantityListeners);
document.addEventListener("shopify:section:load", rebindQuantityListeners);
document.addEventListener("cart:change", rebindQuantityListeners);
